import React, { useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Collapse } from '@material-ui/core'
import {
  ExpandLessRounded as UpIcon,
  ExpandMoreRounded as DownIcon,
} from '@material-ui/icons'

import Typography from '../../atoms/display/typography'
import EscapeDrag from '../../molecules/display/escapeDrag'

import useStyles from './PreChatStyle'

const Survey = (props) => {
  const classes = useStyles()

  const { t } = useTranslation()

  const generalInformation = useSelector((state) => state.generalInformation)
  const [expanded, setExpanded] = useState({
    0: false,
  })

  const handleCollapse = useCallback((index) => {
    setExpanded((expanded) => ({
      ...expanded,
      [index]: !expanded[index],
    }))
  }, [])

  const renderItems = () => {
    const chatId = props?.chatId
    const data =
      generalInformation.conversations[chatId]?.chatInfo?.[props.type]

    return data?.length > 0 ? (
      <>
        {data.map((e) => (
          <tr>
            <td>
              <Typography variant="body1">{e?.label ?? '-'}</Typography>
            </td>
            <td>
              <Typography variant="body1">
                <EscapeDrag>{e?.message ?? '-'}</EscapeDrag>
              </Typography>
            </td>
          </tr>
        ))}
      </>
    ) : (
      <div className={classes.emptySpace}>{t('items.notfound')}</div>
    )
  }

  const renderContent = () => {
    return (
      <>
        <div className={classes.menuBar} onClick={() => handleCollapse(0)}>
          <Typography variant="body1">{t(`commons.${props.type}`)}</Typography>
          <div className={classes.arrowContent}>
            {expanded[0] ? <UpIcon /> : <DownIcon />}
          </div>
        </div>
        <Collapse in={expanded[0]} timeout="auto" unmountOnExit>
          <div className={classes.content}>
            <table width="100%" cellPadding="10">
              <tbody>{renderItems()}</tbody>
            </table>
          </div>
        </Collapse>
      </>
    )
  }

  return renderContent()
}

export default Survey
